import styled from "styled-components";

export const ChartWrapper = styled.div`
  padding: 0px 24px 20px 24px;
  border-bottom: 1px solid var(--hv-border-default);
`;

export const ChartHeader = styled.div`
  padding: 20px 0px 16px 0px;
`;

export const ChartTitle = styled.span`
  font-family: font-family/font-sans;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: var(--hv-text-normal-secondary);
`;

export const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  border-radius: 4px;
  gap: 4px;
  padding-right: 8px;
  padding-left: 8px;
`;

export const ColorBox = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  border-radius: 2px;
  width: 12px;
  height: 12px;
`;

export const Label = styled.span`
  font-family: font-family/font-sans;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: middle;
  color: var(--hv-text-normal-secondary);
`;

export const LegendWrapper = styled.div`
  display: flex;
  padding-bottom: 8px;
  justify-content: space-between;
`;
